import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.md};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 ${({ theme }) => theme.spacing.sm};
  }
`

export const FlexContainer = styled.div<{
  $direction?: 'row' | 'column'
  $align?: 'flex-start' | 'center' | 'flex-end' | 'stretch'
  $justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around'
  $gap?: string
  $wrap?: boolean
}>`
  display: flex;
  flex-direction: ${({ $direction }) => $direction || 'row'};
  align-items: ${({ $align }) => $align || 'flex-start'};
  justify-content: ${({ $justify }) => $justify || 'flex-start'};
  gap: ${({ $gap, theme }) => $gap || theme.spacing.sm};
  flex-wrap: ${({ $wrap }) => ($wrap ? 'wrap' : 'nowrap')};
`

export const GridContainer = styled.div<{
  $columns?: number
  $gap?: string
}>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns || 1}, 1fr);
  gap: ${({ $gap, theme }) => $gap || theme.spacing.md};
`

export const ScrollableContainer = styled.div<{
  $maxHeight?: string
  $hideScrollbar?: boolean
}>`
  overflow-y: auto;
  max-height: ${({ $maxHeight }) => $maxHeight || '100%'};

  ${({ $hideScrollbar }) =>
    $hideScrollbar &&
    `
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  `}
`

export const Section = styled.section<{
  $padding?: string
  $background?: string
}>`
  padding: ${({ $padding, theme }) => $padding || theme.spacing.lg};
  background: ${({ $background, theme }) => $background || theme.colors.background.dark};
`

export const CardGrid = styled(GridContainer)`
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
`
